export default __webpack_public_path__ + "static/media/chantilly2.4a9bcccb.jpg";